import { isAxiosError } from 'axios';
import { IValidation, IValidationResults } from '@/data/models/validation';

type UnknownRecord = Record<string, unknown>;
export const VALIDATION_STATE_VALID = 'Valid';
export const VALIDATION_STATE_ERROR = 'Error';
export const VALIDATION_STATE_WARNING = 'Warning';

function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === 'object' && value !== null;
}

function getValidationPayload(payload: unknown): unknown {
  if (!isRecord(payload)) {
    return null;
  }

  if (Array.isArray(payload.validationResults)) {
    return payload;
  }

  if (Array.isArray(payload.ValidationResults)) {
    return payload;
  }

  return payload.data ?? payload.Data ?? null;
}

export function getInvalidValidationResults(
  validation: IValidation | null | undefined
): IValidationResults[] {
  return (validation?.validationResults ?? []).filter(
    (result) => result.isValid !== VALIDATION_STATE_VALID
  );
}

export function isValidationError(result: IValidationResults): boolean {
  return result.isValid === VALIDATION_STATE_ERROR;
}

export function isValidationWarning(result: IValidationResults): boolean {
  return result.isValid === VALIDATION_STATE_WARNING;
}

export function getValidationIssuesFromPayload(
  payload: unknown
): IValidationResults[] {
  const validationPayload = getValidationPayload(payload);
  if (!isRecord(validationPayload)) {
    return [];
  }

  const validationResults =
    validationPayload.validationResults ?? validationPayload.ValidationResults;
  if (!Array.isArray(validationResults)) {
    return [];
  }

  return (validationResults as IValidationResults[]).filter(
    (result) => result.isValid !== VALIDATION_STATE_VALID
  );
}

export function getValidationErrorsFromPayload(
  payload: unknown
): IValidationResults[] {
  return getValidationIssuesFromPayload(payload).filter(isValidationError);
}

export function getValidationIssuesFromError(
  error: unknown
): IValidationResults[] {
  if (!isAxiosError(error)) {
    return [];
  }

  return getValidationIssuesFromPayload(error.response?.data);
}

export function getValidationErrorsFromError(
  error: unknown
): IValidationResults[] {
  return getValidationIssuesFromError(error).filter(isValidationError);
}
